import { State } from "common/types/redux";

import { getClassName } from "seneca-common/features/class/state/selectors";

import { makeGetNumberOfClassAssignments } from "../state/selectors";

export type AssignmentAnalyticsPayload = {
  classId: string;
  className?: string;
  numUpcomingClassAssignments: number;
  isFirstAssignment: boolean;
};

export default function generateAssignmentAnalyticsPayload(
  state: State,
  classId: string
): AssignmentAnalyticsPayload {
  const numUpcomingClassAssignments =
    makeGetNumberOfClassAssignments(classId)(state);

  return {
    classId,
    className: getClassName(state, classId)!,
    numUpcomingClassAssignments,
    isFirstAssignment: numUpcomingClassAssignments === 1
  };
}
